<template>
  <div>
    
  </div>
</template>
<script>
import { getConfigData } from "@/request/api.js";
import wx from "weixin-js-sdk";
export default {
  props: ["type"],
  components: {
    top,
  },
  data() {
    return {
      url: "",
      latitude: 21.652970, //要去的纬度-地址
      longitude: 110.909436, //要去的经度-地址
      name: "茂名市慢性疾病防治中心(计星院区)",
      address: "广东省茂名市茂南区计星路一巷10号",
    };
  },
  async mounted() {
    let loadDataUrl = window.location.href;
    let url = loadDataUrl.split("#")[0];
    let num = loadDataUrl.split("?")[1];
    switch (num) {
      case "31":
        this.latitude = 21.652970
        this.longitude = 110.909436
        this.name = "茂名市慢性疾病防治中心(计星院区)"
        this.address = "广东省茂名市茂南区计星路一巷10号"
        break;
      case "41":
        this.latitude = 21.658979
        this.longitude = 110.942068
        this.name = "茂名市慢性疾病防治中心(迎宾院区)"
        this.address = "茂名市茂南区迎宾4路162号"
        break;
      case "42":
        this.latitude = 21.658979
        this.longitude = 110.942068
        this.name = "茂名市河东街道社区卫生服务中心"
        this.address = "茂名市茂南区迎宾4路162号"
        break;
      case "43":
        this.latitude = 21.758886
        this.longitude = 110.830456
        this.name = "茂名市慢性疾病防治中心(金塘院区)"
        this.address = "茂名市茂南区191乡道与291省道交叉口东北50米"
        break;
      default:
        break;
    }
    getConfigData(url).then((res) => {
      let that = this
      var _data = res.data.obj[0];
      if (res.data.message == "操作成功") {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: _data.appId, // 必填，公众号的唯一标识
          timestamp: _data.timestamp, // 必填，生成签名的时间戳
          nonceStr: _data.nonceStr, // 必填，生成签名的随机串
          signature: _data.signature, // 必填，签名
          jsApiList: ["getLocation", "openLocation" ], //必填，需要使用的JS接口列表，如我要用的是wx.getLocation，那么我的jsApiList里的就是getLocation
        });
        wx.error(function(res){})
        wx.ready(function () {
          // 则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          wx.getLocation({
            type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              wx.openLocation({
                //​使用微信内置地图查看位置。
                latitude: that.latitude, //要去的纬度-地址
                longitude: that.longitude, //要去的经度-地址
                name: that.name,
                address: that.address,
                scale: 15,
                success:function(e){
                }
              });
            },
            fail: function (err) {
              alert("获取定位位置信息失败！");
            },
            cancel: function (res) {
              alert("用户拒绝授权获取地理位置");
            },
          });
        });
      }
    });
    // window.location.href="http://api.map.baidu.com/marker?location=28.202546,112.886002&title=中房F联邦&content=距麓云路口公交站步行30米&output=html"
  },
  methods: {

  },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/HospitalInformation/CollegesDepartments.vue